"use client";
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";

import Background from "@/../public/png_files/LandingPageBG1.png";
import Logo from "@/../public/png_files/LandingPageLogo.png";
import { css } from "@/../styled-system/css";

import Button from "../ui/Button";

export default function LandingPage() {
  const [isVisible, setIsVisible] = useState(true);

  return (
    <>
      {isVisible && (
        <div
          className={css({
            position: "fixed",
            inset: 0,
            zIndex: 9999,
            display: "flex",
            flexDir: "column",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            pointerEvents: "auto",
          })}
        >
          <Image
            unoptimized
            loading="lazy"
            src={Background}
            fill
            className={css({
              width: "100%",
              height: "100%",
              objectFit: "cover",
              position: "absolute",
            })}
            alt="Solecit Landing Page Background"
          />
          <div
            className={css({
              position: "absolute",
              bottom: "25%",
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              flexDir: "column",
              alignItems: "center",
              gap: "6",
              width: "95%",
            })}
          >
            <div>
              <Image
                unoptimized
                src={Logo}
                alt="Solecit Logo"
                style={{ width: "100%", height: "auto" }}
              />
            </div>
            <div
              className={css({
                display: "flex",
                flexDir: "column",
                gap: "4",
                sm: {
                  flexDir: "row",
                  gap: "32",
                },
                md: {
                  gap: "60",
                },
                justifyContent: "center",
              })}
            >
              <Button
                variant="nonMemberEnter"
                onClick={() => setIsVisible(false)}
              >
                ENTER
              </Button>
              <Link href="/sign-in">
                <Button variant="memberLogIn">LOG IN</Button>
              </Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
